var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 3.13529,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_26957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9875 21.1016H30.0137C29.2115 21.1016 28.561 21.752 28.561 22.5542V37.4438C28.561 38.246 29.2115 38.8964 30.0137 38.8964H49.9875C50.7898 38.8964 51.4402 38.246 51.4402 37.4438V22.5542C51.4402 21.752 50.7898 21.1016 49.9875 21.1016ZM49.9875 22.5542V33.1189L47.1247 30.5161C46.6944 30.125 46.0327 30.1406 45.6216 30.5521L42.7242 33.449L37.0114 26.6252C36.5796 26.1095 35.7886 26.1044 35.3503 26.6139L30.0137 32.816V22.5542H49.9875ZM43.8138 26.3674C43.8138 25.2641 44.7079 24.37 45.8111 24.37C46.9145 24.37 47.8085 25.2641 47.8085 26.3674C47.8085 27.4707 46.9145 28.3647 45.8111 28.3647C44.7079 28.3648 43.8138 27.4707 43.8138 26.3674Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3051_26957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8792,
    height: 22.8792,
    fill: "white",
    transform: "translate(28.5605 18.5605)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.1432282fe85d221860329df180f9e1dc.svg";
export { ForwardRef as ReactComponent };